import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ProjekteService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ProjekteService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ProjekteServiceModule {}
